export default "__VITE_ASSET__Cwk2Z__u__"